import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, propEq, find, filter, path, contains } from 'ramda';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import magic from '../../../../util/magic';
import certificationActions from '../../../../redux/certification/index';
import registrationActions from '../../../../redux/registration/index';
import userActions from '../../../../redux/user/index';
import { apiGetRegistration } from '../../../../api/registration';

import PreRegistration from './Statuses/PreRegistration';
import RegistrationApproval from './Statuses/RegistrationApproval';
import PostRegistration from './Statuses/PostRegistration';
import FinalApproval from './Statuses/FinalApproval';
import Completed from './Statuses/Completed';
import { getRegistrationExpirationInfo } from '../../../../util/helpers';
import ExperienceApproval from './Statuses/ExperienceApproval';

const mapStore = (store, { match }) => {
  const selectedCertificationId = Number(match.params.type);
  const certification = defaultTo({}, find(propEq('id', selectedCertificationId), store.certifications));
  certification.trainings = defaultTo([], filter(propEq('certificationId', selectedCertificationId))(store.trainings));

  return {
    areasOfExpertise: store.areasOfExpertise,
    donations: store.donations,
    certification,
    memberships: store.memberships,
    registration: store.registration,
    universities: store.universities,
    user: store.user,
    workAreas: store.workAreas,
  };
};

const mapDispatch = {
  ...userActions,
  ...certificationActions,
  ...registrationActions,
};

class Registration extends Component {
  static propTypes = {
    clearRegistration: PropTypes.func,
    certification: PropTypes.object,
    registration: PropTypes.object,
    overwriteRegistration: PropTypes.func,
  };

  state = {
    loaded: false,
  };

  componentDidMount() {
    const { user, clearRegistration, overwriteRegistration, match } = this.props;
    const selectedCertificationId = Number(match.params.type);
    const registration = find(propEq('certificationId', selectedCertificationId), user.latestRegistrations);
    getRegistrationExpirationInfo(registration, user.extensions);

    if (!registration || registration.expirationStatus == magic.expired) {
      clearRegistration();
      this.setState({ loaded: true });
    } else {
      apiGetRegistration(registration.id)
        .then((resp) => overwriteRegistration(resp.data))
        .then(() => this.setState({ loaded: true }));
    }
  }

  render() {
    if (!this.state.loaded) return <noscript />;
    const { registration } = this.props;
    const status = defaultTo(magic.preRegistration, path(['status'], registration));

    if (status == magic.preRegistration) return <PreRegistration {...this.props} />;
    if (status == magic.registrationApproval) return <RegistrationApproval {...this.props} />;
    if (status == magic.experienceApproval) return <ExperienceApproval {...this.props} />;
    if (contains(status, [magic.postRegistration, magic.moduleApproval])) return <PostRegistration {...this.props} />;
    if (status == magic.finalApproval) return <FinalApproval {...this.props} />;
    if (status == magic.complete) return <Completed {...this.props} />;

    return <noscript />;
  }
}

export default withRouter(connect(mapStore, mapDispatch)(Registration));
